export const EVENT_COMPANY_PARTICIPATION_PAGE_CONST = {
    localStorage: {
        sidebarCollapseKey: 'eventCompanyParticipationSidebarCollapsed',
    },
    collapsedWidth: 40,
    expandedWidth: 260,
    tabContentHeight: 'calc(100vh - 156px)', // Adjusted to match the height of the sidebar content
};
